/**
 * Bundled community recipes offered as one-click quick-adds in the BYOR modal
 * (§4.8.3). These are the same files anyone can read in
 * `recipes/community/` — bundling them here only saves a visitor from typing
 * a URL by hand. It changes nothing about when a fetch happens: clicking one
 * still triggers a single, user-initiated fetch through `/api/fetch`, exactly
 * like pasting the URL into URL mode, and still requires review before it is
 * added to the board (FR-48). Nothing here is fetched on a schedule or served
 * to a second visitor.
 *
 * Order is display order. FantasyPros ECR is listed first — it is a
 * multi-expert consensus across the full free player pool, not a single
 * analyst's list capped at a teaser depth — but it is still one tap away
 * from Winks, never fetched without the visitor choosing it.
 */

import { recipeFromYaml, type Recipe } from '../core/byor/recipes.ts';
import fantasyProsEcrYaml from '../../recipes/community/fantasypros-ecr.yml?raw';
import winksYaml from '../../recipes/community/winks.yml?raw';

function load(yaml: string): Recipe {
  const { recipe, errors } = recipeFromYaml(yaml);
  if (!recipe) throw new Error(`Bundled recipe failed to parse: ${errors.join('; ')}`);
  return recipe;
}

export const KNOWN_RECIPES: Recipe[] = [load(fantasyProsEcrYaml), load(winksYaml)];
